import React from "react";

import { useTranslation } from "react-i18next";

import SwitchOnOff from "../../common/tools/SwitchOnOff";
import InfoTooltip from "../../utils/InfoTooltip";

import type { JSX } from "react";

import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";

interface PlayerConfigurationProps {
  hasAllowUpnext: boolean;
  hasAllowPlayerMirror: boolean;
  hasAllowPreview: boolean;
  hasAllowMediaResume: boolean;
  onChange: <K extends keyof StorefrontProjectParams>(
    key: K,
    value: StorefrontProjectParams[K],
  ) => void;
}

export default function PlayerConfiguration({
  onChange,
  hasAllowUpnext,
  hasAllowPlayerMirror,
  hasAllowPreview,
  hasAllowMediaResume,
}: PlayerConfigurationProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("playerSettings")}</div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasAllowUpnext ?? false}
            iconName=""
            name="display_item_title"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("allow_upnext", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableUPNext")}</div>
        <InfoTooltip>{t("playerUpNextTooltip")}</InfoTooltip>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasAllowPlayerMirror ?? false}
            iconName=""
            name="allow_player_mirror"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("allow_player_mirror", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableMirrorMode")}</div>
        <InfoTooltip>{t("mirrorModeTooltip")}</InfoTooltip>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasAllowPreview ?? false}
            iconName=""
            name="allow_preview"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("allow_preview", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enablePreview")}</div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            checked={hasAllowMediaResume ?? false}
            iconName=""
            name="allow_media_resume"
            size="sm"
            onChange={(value: boolean): void => {
              onChange("allow_media_resume", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableResume")}</div>
      </div>
    </div>
  );
}
